import { Component, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';
import { AlertService } from './alert.service';
import { Alert } from '@app/core/interfaces/alert-interface';


@Component({
  standalone: false,
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit, OnDestroy {

  @ViewChild('toast', {static: false}) toast: ElementRef;

  alert = null;
  stream$: Subscription;

  constructor(private alertService: AlertService) {}

  ngOnInit(): void {
    this.stream$ = this.alertService.getErrorStream()
      .subscribe((alert: Alert) => alert ? this.openToast(alert) : null);
  }

  ngOnDestroy(): void {
    this.stream$.unsubscribe();
  }

  openToast(alert: Alert): void {
    this.alert = alert;
    this.toast.nativeElement.open();
  }

}
